import type { ReactNode } from 'react';
import { Box } from '@cbhq/cds-web/layout';
import { PortalProvider } from '@cbhq/cds-web/overlays/PortalProvider';
import { MediaQueryProvider, ThemeProvider as CDSThemeProvider } from '@cbhq/cds-web/system';
import { coinbaseTheme } from '@cbhq/cds-web/themes/coinbaseTheme';
import { SpectrumProvider, useSpectrum } from '@cbhq/identity-shared';

type ThemeProviderProps = {
  children: ReactNode;
};

function InnerThemeProvider({ children }: ThemeProviderProps) {
  const { spectrum } = useSpectrum();
  const resolvedSpectrum = spectrum ?? 'light';

  return (
    <MediaQueryProvider>
      <CDSThemeProvider theme={coinbaseTheme} activeColorScheme={resolvedSpectrum} isolated>
        <PortalProvider>
          <Box background="bg" minHeight="100%" width="100%" flexDirection="column">
            {children}
          </Box>
        </PortalProvider>
      </CDSThemeProvider>
    </MediaQueryProvider>
  );
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <SpectrumProvider>
      <InnerThemeProvider>{children}</InnerThemeProvider>
    </SpectrumProvider>
  );
}
